// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"eb512466","703":"c76a86d7"}[chunkId] + ".chunk.js";
};